<template>
  <div class="v-application">
    <div class="login-content d-flex align-items-center">
      <div v-if="configuracion.activo" class="mensaje-global">{{ configuracion.valor }}</div>
      <!-- <div class="mensaje-global">Estimado Usuario, nos encontraremos en MANTENCIÓN DE SERVICIOS, a partir de las 17:00 horas del día Sábado 8 de junio, hasta las 14:00 horas del Domingo 9 de Junio,
 se recomienda no hacer pagos por el botón o depósitos directos.</div> -->
      <vue-aos animation-class="fadeUp animated" class="container">
        <div class="container">
          <div class="row">
            <div
              class="col-lg-6 aos-init aos-animate text-center d-none d-lg-block"
              data-aos="fade-right"
              data-aos-delay="100"
            >
              <h2>PORTAL BACKOFFICE</h2>
              <h1>
                Paga todos los documentos asociados a tus empresas en un solo
                lugar.
              </h1>
              <img src="media/img/login.png" class="img-fluid" alt="" />
            </div>
            <div
              class="col-lg-6 align-items-stretch aos-init aos-animate pt-4 pt-lg-0 content d-flex flex-column justify-content-center"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <router-view></router-view>
            </div>
          </div>
        </div>
      </vue-aos>
    </div>
    <footer id="footer">
      <div class="container pt-4 d-flex justify-content-between">
        <div class="copyright">
          <!-- &copy; Copyright <strong><span>Socofar</span></strong>. All Rights Reserved -->
        </div>
        <div class="logo">
          <img class="" src="media/img/femsa-gris.png" alt="" width="150" />
          <p>©2020</p>
        </div>

        <div class="credits">
          <!-- Designed by <a href="https://bootstrapmade.com/">Soledad Moris</a> -->
        </div>
      </div>
    </footer>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import { mapState } from "vuex";
import VueAos from "vue-aos";
import { GET_CONFIGURACION } from "@/core/services/store/configuracion.module";
export default {
  name: "auth",
  components: { VueAos },
  data() {
    return {
      tituloError: null,
      descripcionError: null,
      modalError: false,
      fab: false,
      hidden: false,
      tabs: null,
      configuracion: {},
    };
  },
  mounted() {
    this.obtenerConfiguracion();
  },
  methods: {
  obtenerConfiguracion() {
    this.$store
      .dispatch(GET_CONFIGURACION, "MENSAJEGLOBAL")
      .then((response) => {
        (this.configuracion = response), (this.loading = false);
      });
  }
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    backgroundImage() {
      return process.env.BASE_URL + "media/bg/bg-4.jpg";
    },
  },
};
</script>
<style  scoped>
.v-btn--absolute {
  bottom: 0px !important;
  position: fixed;
}
.mensaje-global {
  background: rgb(245, 158, 11);
  color: black;
  font-size: 1.1rem;
  font-weight: 500;
  padding: 15px 20px;
  width: 100%;
  text-align: center;
  margin: 0;
  position: fixed;
  top: 0;
}
</style>
